import { Injectable } from "@angular/core";
@Injectable()
export class ApplicationConfig {
  public readonly DEFAULT_PRIMARY_COLOR: string = '#f49b05';
  public readonly DEFAULT_PRIMARY_TEXT_COLOR: string = '#ffffff';
  public readonly DEFAULT_SECONDARY_COLOR: string = '#4a4a4a';
  public readonly DEFAULT_SECONDARY_TEXT_COLOR: string = '#ffffff';
  public readonly DEFAULT_FONT: string = 'Roboto';
  public readonly DEFAULT_TEXT_COLOR: string = '#000';
  public readonly DEFAULT_TITLE_TEXT_COLOR: string = '#000';
  public readonly DATE_FORMAT: string = 'dd/MM/yyyy';
  public readonly DATE_TIME_FORMAT: string = 'dd/MM/yyyy, HH:mm';
  public readonly DEFAULT_LOGO_URL: string = 'assets/company-logo.png';
  public readonly DEFAULT_BACKGROUND_URL: string = 'assets/background.jpg';
  public readonly MIN_PASSWORD_LENGTH: number = 6;
}
